"use client";

import { FC, PropsWithChildren } from "react";
import Footer from "components/footer/Footer";
import MainContent from "components/MainContent";

export const CommonLayout: FC<PropsWithChildren> = ({ children }) => {
    const content = (
        <MainContent>
            {children}
            <Footer />
        </MainContent>
    );
    return content;
};
